import React, { useMemo, useState } from "react";
import { BookCheck } from "lucide-react";

import { useAppSelector } from "../../../app/hooks";

import { InvestigationEntityCard } from "./InvestigationEntityCard";

import CreditAccountsModal from "../../creditAccounts/components/CreditAccountsModal";
import { getAccountProductInfo } from "../../creditAccounts/logic/slice";
import LoanAccountPopoverRow from "../../creditAccounts/components/LoanAccountPopoverRow";

export enum EntityModalType {
  ADD = "add",
  MANAGE = "manage",
}

const LoanAccountCard: React.FC = () => {
  const loanReferences = useAppSelector(getAccountProductInfo);

  const [activeModal, setActiveModal] = useState<EntityModalType | null>(null);

  const accountItems = useMemo(
    () => loanReferences?.map((loan) => loan.ext_account_number),
    [loanReferences],
  );

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <>
      <InvestigationEntityCard
        title="Loan Accounts"
        items={accountItems}
        onAdd={() => setActiveModal(EntityModalType.ADD)}
        onManage={() => setActiveModal(EntityModalType.MANAGE)}
        popoverProps={{
          title: "Loan Accounts",
          icon: <BookCheck size={16} className="text-[#94A3B8]" />,
          items: loanReferences.map((account, index) => ({
            content: (
              <LoanAccountPopoverRow account={account} showDivider={index > 0} />
            ),
            copyValue: account.ext_account_number,
          })),
        }}
        emptyState={{
          icon: <BookCheck size={18} className="text-[#94A3B8]" />,
          message: "No accounts added",
        }}
      />

      {activeModal && (
        <CreditAccountsModal
          onClose={closeModal}
          onBack={closeModal}
          prefillExisting={activeModal === EntityModalType.MANAGE}
          title={
            activeModal === EntityModalType.MANAGE
              ? "Manage Loan Accounts"
              : "Add Loan Accounts"
          }
        />
      )}
    </>
  );
};

export default LoanAccountCard;
